import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export type DiscardOrderDialogType = 'newOrder' | 'existingOrder';

interface DiscardOrderDialogProps {
  open: boolean;
  type: DiscardOrderDialogType;
  onCancel: () => void;
  onDiscard: () => void;
}

export const DiscardOrderDialog: React.FC<DiscardOrderDialogProps> = ({
  open,
  type,
  onCancel,
  onDiscard,
}) => {
  const isNew = type === 'newOrder';

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle id="qa-title-lbl">
        {isNew ? 'Discard This Order?' : 'Discard Changes?'}
      </DialogTitle>
      <DialogContent>
        {isNew ? (
          <Typography id="qa-paragraph-txt" className="notice">
            Are you sure you want to discard this order? All information entered will be deleted
            and the product list cleared. The order cannot be recovered once discarded.
          </Typography>
        ) : (
          <Typography id="qa-paragraph-txt" className="notice">
            Are you sure you want to discard any recent changes to this order?
            All product and detail updates will be deleted.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          id="qa-cancel-btn"
          variant="contained"
          onClick={onCancel}
          sx={{
            backgroundColor: '#0c479d',
            color: '#ffffff',
            '&:hover': { backgroundColor: '#083380' },
          }}
        >
          CANCEL
        </Button>
        <Button
          id="qa-discardOrder-btn"
          variant="contained"
          onClick={onDiscard}
          sx={{
            ml: 2.5,
            color: '#d32f2f',
            backgroundColor: '#ffffff',
            '&:hover': { color: '#b71c1c', backgroundColor: '#f5f5f5' },
          }}
        >
          {isNew ? 'DISCARD ORDER' : 'DISCARD CHANGES'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
